import React from 'react';
import { withRouter } from 'react-router-dom';

const MovieCard = ({movie, history}) => {

    const getMovieDetails = (imdbId) => {
        history.push('/details?imdbId=' +imdbId);
        console.log(imdbId);
    }

    return <div className="col-md-3">
        <div className="card" onClick={() => getMovieDetails(movie.imdbID) } >
            <div className="card-body">
                <h4 className="card-title">{movie.Title}</h4>
                <p className="card-text">{movie.Year}</p>
            </div>
            <img src={movie.Poster} alt={movie.Title} className="card-img-top" />
        </div>
    </div>;
}

export default withRouter(MovieCard);